import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SocialIcon } from 'react-social-icons';
import HeroSection from '../components/HeroSection';
import CoursesSection from '../components/CoursesSection';
import WhyUsSection from '../components/WhyUsSection';
import PricingSection from '../components/PricingSection';
import TeachersSection from '../components/TeachersSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Sigma Study - Profesjonalne Korepetycje z Matematyki Online</title>
        <meta name="description" content="Sigma Study - Profesjonalne korepetycje z matematyki online. 97% uczniów poprawia oceny w pierwszym miesiącu! Matura, olimpiady, egzaminy zagraniczne." />
        <link rel="canonical" href="https://sigmastudy.pl/" />
      </Helmet>

      <HeroSection />
      <CoursesSection />
      <WhyUsSection />
      <TeachersSection />
      <PricingSection />
      <TestimonialsSection />
      <ContactSection />

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img
                  src="/logo_sigma/SVG/white.svg"
                  alt="Sigma Study School Logo"
                  className="footer-logo-img"
                />
              </div>
            </div>

            <div className="footer-section no-hover">
              <h4>Zajęcia</h4>
              <ul>
                <li>Szkoła Podstawowa</li>
                <li>Matematyka Olimpijska</li>
                <li>Matematyka Liceum</li>
                <li>Przygotowanie do Matury</li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Kontakt</h4>
              <p>📞 +48 532 533 220</p>
              <p>📧 info@sigma-study.net</p>
            </div>

            <div className="footer-section">
              <h4>Nasze social media</h4>
              <div className="social-links">
                <div style={{ display: 'flex', gap: '12px' }}>
                  <SocialIcon url="https://www.facebook.com/people/Sigma-Study/61576967721817/" style={{ height: 35, width: 35 }} />
                  <SocialIcon url="https://www.instagram.com/sigma_study_/" style={{ height: 35, width: 35 }} />
                </div>

              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 Wszystkie prawa zastrzeżone.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HomePage;
